/**
 * @(#)2019/6/12.
 * Date，用于选择时间和日期
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import "./index.less";
import Moment from "moment";
import BaseDate from "./BaseDate";
import TimeRange from "./TimeRange";
import Basics from "../Basics";
import { types } from "./tools";
import React, { Component } from "react";
import { Connection, YxComponent } from "../../YxComponent";
import { l } from "../../../config/language";
import { reduce } from "lodash";

/*
 * @param children {ReactNode} react节点
 * @param styleParam {object} 样式参数
 * @param styleParam.width {object} 宽度  xxs,xs,sm,md,lg,xl
 * @param type {enum} 控件类型 date/month/range/week/time/timeRange  日期/月份/范围/周/时间/时间范围
 * @param format {string || array} 时间显示格式  默认值 YYYY-MM-DD HH:mm:ss（日期） HH:mm:ss （时间）
 * */

//默认props
let defaul = () => {
  return {
    children: "", //子节点
    rules: {},
    inputParam: {},
    getFieldDecoratorParam: {},
    format: "", //日期默认值 YYYY-MM-DD HH:mm:ss，时间默认值 HH:mm:ss
    type: "date", // date/month/range/week/time/timeRange  日期/月份/范围/周/时间/时间范围
    styleParam: {
      width: "datesm", //宽度  xxs,xs,sm,md,lg,xl
      size: "default", //大小
      type: "default", //类型
    },
  };
};
@Connection(defaul)
class Date extends YxComponent {
  get controlType() {
    const types_ = types();
    const { type, controlType } = this.props;
    const list = [type, controlType, "date"];
    const result = list.find((l) => types_.includes(l));
    return result;
  }

  rules(tmpProps) {
    //验证是否为空
    let { format } = tmpProps;
    if (tmpProps.rules.required === true) {
      tmpProps.rules.validator = {
        validator: async (rule, value, callBack) => {
          let start = value[0];
          let end = value[1];
          if (!start || !end) {
            callBack(l("Range.pc", this, { label: tmpProps.label }));
          }
        },
      };
    }
    // 验证是否时间范围可以超过一天
    return tmpProps;
  }

  productionHtml() {
    let tmpProps = { ...this.props, rules: { ...this.props.rules } };
    tmpProps.rules.max = "";
    const controlType = this.controlType;
    //根据不同类型设置不同默认值
    if (controlType == "timeRange") {
      this.rules(tmpProps);
    }
    if (!tmpProps.format) {
      tmpProps.format =
        controlType != "time" && controlType != "timeRange"
          ? "YYYY-MM-DD HH:mm:ss"
          : "HH:mm:ss";
    }
    tmpProps.getFieldDecoratorParam.valuePropName = "value";
    tmpProps.getFieldDecoratorParam.validateTrigger = "onChange";
    tmpProps.getFieldDecoratorParam.trigger = "onChange";
    tmpProps.getFieldDecoratorParam.getValueFromEvent = (info) => {
      return info;
    };

    if (controlType == "range") {
      if (tmpProps.format.length > 12) {
        tmpProps.styleParam.width = "datelg";
      } else {
        tmpProps.styleParam.width = "datemd";
      }
    }
    if (controlType == "time" || controlType == "timeRange") {
      tmpProps.styleParam.width = "timesm";
    }

    let classParam = {
      yx_yxDate_: "styleParam.type",
      yx_yxDate_size_: "styleParam.size",
      yx_yxInput_width_: "styleParam.width",
    };
    tmpProps.inputParam.className =
      this.styleParamClassName(tmpProps, classParam) + " yx_yxDate_box";
    if (controlType != "timeRange") {
      tmpProps.children = (
        <BaseDate format={tmpProps.format} type={this.controlType} />
      );
    } else {
      tmpProps.initValue = tmpProps.defaultValue;
      tmpProps.getFieldDecoratorParam.valuePropName = "setValue";
      tmpProps.children = <TimeRange {...tmpProps} type={this.controlType} />;
    }
    let html = Basics.html(tmpProps);
    return html;
  }

  render() {
    const type = this.controlType;
    return this.productionHtml();
  }
}
export default Date;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/Date/Date.js